import * as React from "react";
import {
    UitkButtonSize,
    UitkCard,
    UitkHeading,
    UitkPrimaryButton,
    UitkSpacing,
    UitkSubheading,
} from "@egencia/uitk-react";

const {chatData, anonymousUser} = EG.bootstrapped;

export const ChatButton = () => {
    const chatHelpTitle = uitk.i18n.msg('need_help_title');
    const chatHelpSubTitle = uitk.i18n.msg('contact_chat_subtitle')
    const chatButtonLabel = uitk.i18n.msg("new_contact_chat");

    function handleClickChat(e) {
        omnitureLog.logClickEvent(EG.pageName + '.Chat.Clicked')
        window.openChat(e)
    }

    function getChatButton() {
        if (anonymousUser) return <></>;
        if (!chatData.showChatButton) return <></>;

        if (chatData.chatBotOrCpEnabled) {
            return (
                <UitkCard padding={"medium"} border={true}>
                    <UitkHeading tag={"h2"} size={4}>{chatHelpTitle}</UitkHeading>
                    <UitkSubheading tag={"h4"} size={7}>{chatHelpSubTitle}</UitkSubheading>
                    <UitkSpacing margin={{blockstart: "four"}}>
                        <UitkPrimaryButton
                            icon="chat"
                            className="chatbot-btn btn-chat"
                            id="btn-chat"
                            isFullWidth="true"
                            size={UitkButtonSize.LARGE}
                            onClick={handleClickChat}
                        >{chatButtonLabel}</UitkPrimaryButton>
                    </UitkSpacing>
                </UitkCard>
            );
        }
    }

    return getChatButton()
};